import { Component, OnInit } from '@angular/core';
import{ActivatedRoute,Router}from'@angular/router';
import{MentorAuthService}from'../../services/mentor-auth.service'
@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {
  verification=true;
  token:String;
  messageToDisplay:String=''
  showLogin=false;
  constructor(private activatedRoute:ActivatedRoute,private router:Router,private mentorAuthService:MentorAuthService) { }

  ngOnInit(){
    this.token=this.activatedRoute.snapshot.paramMap.get('token')
    console.log(this.token)
    if(!this.token||this.token==''){
      this.router.navigate(['/'])
    }
    else{
      this.mentorAuthService.confirmEmail(this.token).subscribe(
        (result)=>{
          this.messageToDisplay='Email verified successfully. Login to access your account'
          this.showLogin=true
          this.verification=false
        },
        (error)=>{
          if(error.status==400){
            this.router.navigate(['/login/mentor'])
          }
          
        }
      )
    }
  }

}
